<template>
  <div class="feature" :style="largeScreenContainer">
    <v-container>
      <v-row>
        <v-col cols="12" md="6">
          <div class="feature-left">
            <div
              key="1"
              class="feature-bar-item"
              :class="{ 'feature-bar-active': activeBar === 1 }"
            >
              <div
                v-if="activeBar != 1"
                @click="activeBar = 1"
                class="feature-bar-tagline"
              >
                Lorem ipsum dolor
              </div>
              <div v-if="activeBar === 1" class="feature-bar">
                <div class="feature-bar-tag">
                  Feature
                </div>
                <div class="feature-bar-title">
                  Lorem ipsum dolor
                </div>
                <div class="feature-bar-desc">
                  Lorem ipsum dolor sit amet, consetetur sadipscing elitr,
                </div>
              </div>
            </div>
            <div
              key="2"
              class="feature-bar-item"
              :class="{ 'feature-bar-active': activeBar === 2 }"
            >
              <div
                v-if="activeBar != 2"
                @click="activeBar = 2"
                class="feature-bar-tagline"
              >
                Lorem ipsum dolor
              </div>
              <div v-if="activeBar === 2" class="feature-bar">
                <div class="feature-bar-tag">
                  Feature
                </div>
                <div class="feature-bar-title">
                  Lorem ipsum dolor
                </div>
                <div class="feature-bar-desc">
                  Lorem ipsum dolor sit amet, consetetur sadipscing elitr,
                </div>
              </div>
            </div>
            <div
              key="3"
              class="feature-bar-item"
              :class="{ 'feature-bar-active': activeBar === 3 }"
            >
              <div
                v-if="activeBar != 3"
                @click="activeBar = 3"
                class="feature-bar-tagline"
              >
                Lorem ipsum dolor
              </div>
              <div v-if="activeBar === 3" class="feature-bar">
                <div class="feature-bar-tag">
                  Feature
                </div>
                <div class="feature-bar-title">
                  Lorem ipsum dolor
                </div>
                <div class="feature-bar-desc">
                  Lorem ipsum dolor sit amet, consetetur sadipscing elitr,
                </div>
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="6">
          <div class="feature-right">
            <img
              v-if="activeBar === 1"
              key="1"
              src="@/assets/img/feature.jpg"
              alt=""
            />
            <img
              v-if="activeBar === 2"
              key="2"
              src="@/assets/img/feature.jpg"
              alt=""
            />
            <img
              v-if="activeBar === 3"
              key="3"
              src="@/assets/img/feature.jpg"
              alt=""
            />
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div class="feature-other">
            <p class="feature-other-title">What others say about us</p>
            <p class="feature-other-desc">
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
              nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
              erat, sed diam voluptua. At vero eos et accusam
            </p>
            <div class="feature-other-bottom">
              <img src="@/assets/img/feature-other-profil.jpg" alt="" />
              <div class="feature-other-info">
                <div class="feature-other-name">BRANDY MILLER</div>
                <div class="feature-other-job">Freelancer</div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeBar: 1,
    };
  },
};
</script>

<style lang="scss">
.feature {
  padding: 110px 0;
  color: #000;
  margin-top: 30px;

  &-left {
    padding-right: 88px;

    &-desc {
      font-size: 30px;
      margin-top: 18px;
      color: #000;
    }
  }
  &-right {
    text-align: right;
    img {
      height: 370px;
    }
  }
  &-other {
    margin-top: 100px;
    text-align: center;
    &-title {
      font-size: 40px;
      font-weight: bold;
      margin-bottom: 80px !important;
    }
    &-desc {
      margin: 0 auto;
      margin-bottom: 57px !important;
      max-width: 700px;
    }
    &-bottom {
      display: flex;
      justify-content: center;

      img {
        height: 85px;
        width: 85px;
        margin-right: 30px;
      }
    }
    &-info {
      display: flex;
      align-items: flex-start;
      justify-content: center;
      flex-direction: column;
    }
    &-name {
      color: #000;
      margin-bottom: 10px;
    }
    &-job {
      color: #777777;
    }
  }

  &-bar {
    background-color: #6021ff;
    transition: all 0.3s;
    padding: 0;
    transition: all 2s;

    &-active {
      margin-bottom: 16px;
      transition: all 2s;

      .feature-bar {
        color: #fff;
        padding: 18px 29px;
      }
    }

    &-tagline {
      width: 100%;
      margin-bottom: 14px;
      font-size: 30px;
      cursor: pointer;
    }

    &-item {
      height: auto;
      transition: all 0.3s;
      min-height: 0;
    }

    &-tag {
      font-weight: bold;
      margin-bottom: 16px;
    }
    &-title {
      font-size: 30px;
      margin-bottom: 16px;
      cursor: pointer;
    }
    &-desc {
    }
  }
}
@include smMax {
  .feature {
    padding-top: 0;
    padding-bottom: 67px;
    &-left {
      padding-right: 0;

      &-desc {
        text-align: center;
      }
    }
    &-bar {
      text-align: center;
      padding: 18px 14px;

      &-tagline {
        text-align: center;
        font-size: 23px;
      }
    }
    &-right {
      img {
        height: 100%;
        width: 100%;
      }
    }
    &-other {
      margin-top: 30px;

      &-title {
        margin-bottom: 20px !important;
      }
      &-desc {
      }
    }
  }
}
</style>
